var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoHuaweiAppGallery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M6.734 0C1.804 0 0 1.803 0 6.733v10.534C0 22.197 1.803 24 6.734 24h10.529C22.193 24 24 22.197 24 17.267V6.733C24 1.803 22.197 0 17.266 0H6.734Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.469 13.92h.963l-.483-1.125-.48 1.124Zm-.238.566-.285.654h-.651L10.679 12h.562l1.379 3.14h-.668l-.283-.654h-1.438Zm10.473.652h.63V12h-.63v3.138Zm-2.503-1.348h1.16v-.572H18.2v-.643h1.683v-.573h-2.312v3.138h2.373v-.572H18.2v-.778Zm-2.5.37L14.988 12h-.52l-.713 2.16-.694-2.158h-.679l1.095 3.14h.528l.714-2.063.714 2.063h.533l1.092-3.14h-.661l-.696 2.159Zm-7.366-.36c0 .51-.254.783-.715.783-.463 0-.718-.28-.718-.805v-1.775h-.637V13.8c0 .883.49 1.39 1.347 1.39.864 0 1.36-.516 1.36-1.417V12h-.637v1.8ZM4.744 12h.637v3.142h-.637v-1.276h-1.44v1.276h-.637V12h.637v1.268h1.44V12ZM12 8C9.794 8 8 6.206 8 4h.565A3.439 3.439 0 0 0 12 7.435 3.439 3.439 0 0 0 15.435 4H16c0 2.206-1.794 4-4 4Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoHuaweiAppGallery);
export default __webpack_public_path__ + "static/media/ic_logo_huawei_app_gallery.85544fe8c436024415c8419050ca25e1.svg";
export { ForwardRef as ReactComponent };